type ErrorOptions = {
  mechanism?: "manual" | "onerror" | "unhandledrejection" | "react_error_boundary";
  handled?: boolean;
  severity?: "error" | "warning" | "info";
};

/**
 * Reports a runtime error to any registered error-tracking integration.
 * Extend this function to wire in Sentry, Datadog, or any other provider.
 */
export function reportError(
  error: unknown,
  context: Record<string, unknown> = {},
  options: ErrorOptions = {},
) {
  if (typeof window === "undefined") return;

  const message =
    error instanceof Response
      ? `Response ${error.status}${error.url ? ` at ${error.url}` : ""}`
      : error instanceof Error
        ? error.message
        : String(error);

  const stack = error instanceof Error ? error.stack : undefined;

  // Log to console in development for immediate visibility.
  if (import.meta.env.DEV) {
    console.error("[reportError]", message, { context, options, stack });
  }

  // TODO: forward to your error-tracking provider here, e.g.:
  // Sentry.captureException(error, { extra: context });
}
